<template>
  <div class="token">
    <h1>Sono 10 giorni che manca la connessione internet ...</h1>
    <img :src="`${publicPath}img/ubisell-logo.png`" >
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style scoped>
  .token {
    display: block;
    width: 100vw;
    height: 100vh;
    text-align: center;
    box-sizing: border-box;
    padding-top: 20vh;
  }
</style>
